import { render, staticRenderFns } from "./add-group-member.vue?vue&type=template&id=5d05f520&scoped=true"
import script from "./add-group-member.vue?vue&type=script&lang=js"
export * from "./add-group-member.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d05f520",
  null
  
)

export default component.exports